import { Component, HostListener, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { environment } from 'environments/environment';
import { ErrorService } from 'services/error.service';
import { ProspectService } from 'services/prospect.service';

@Component({
  selector: 'app-verifast-iframe',
  templateUrl: './verifast-iframe.component.html',
  styleUrls: ['./verifast-iframe.component.css']
})
export class VerifastIframeComponent implements OnInit {
  @Input() iFrameURL: string;
  @Input() getVerifastUrl: () => void;
  @Input() setfailedResult: (isLoading: boolean) => void;
  @Input() setIsLoadingFunc: (isLoading: boolean) => void;
  @Input() setVerificationResult: (income: boolean) => void;
  @Input() setShowIframe: (show: boolean) => void;

  @HostListener('window:message', ['$event'])
  MessageReceived(event: MessageEvent) {
    // Verifast V2
    if (environment.enableVerifastV2) {
      if (event.origin === environment.verifastOrigin
      && event.data.event
      && (event.data.event === "employment-verification-complete"
        || event.data.event === "identity-verification-complete"
        || event.data.event === "bank-verification-complete")) {
        this.verifyVerifastResult();
      }
    }
    else {
      // Verifast V1
      if (event.origin === environment.verifastOrigin 
      && event.data.detail 
      && (event.data.detail === "employment-complete" 
        || event.data.detail === "identity-verification-complete" 
        || event.data.detail === "bank-verification-complete")) {
      if (event.data.detail) {
          this.verifyVerifastResult();
        }
      }
    }
  }
  
  constructor( private prospectService: ProspectService, private errorService: ErrorService) {
  }

  ngOnInit(): void {
  }
  
  verifyVerifastResult = () => {
    this.setIsLoadingFunc(true);
    let i = 0;
    (async () => {
      let sessionId = localStorage.getItem("verifastSessionId");
      var isIncome = false;
      var isIncomeSession = localStorage.getItem("isIncomeSession");
      if (isIncomeSession !== null && isIncomeSession === "true") {
        isIncome = true;
      }
      await this.prospectService.SetVerificationCompletedDate(sessionId).toPromise();
      let duplicateId = false;
      let isApplication = localStorage.getItem("ApplicationWorkflow");

      // Call API once every 5 seconds for 3 minutes
      while (i++ < 36) {
        let status = await this.prospectService.GetVerifastStatusBySessionId(isIncome, sessionId).toPromise();

        if (!status.localeCompare("success", undefined, { sensitivity: 'accent' })) {
          if(isApplication === 'true' && isIncome) {
            this.setVerificationResult(isIncome);
            this.setIsLoadingFunc(false);
          } else if(isApplication === 'true' && !isIncome){
            // Dont stop loading as we will show the confirm info step next when its backend call completes
            this.setVerificationResult(isIncome);
          }
           else {
            this.prospectService.CheckProspectStatus();
          }
          return;
        }
        else if (!status.localeCompare("failed", undefined, { sensitivity: 'accent' })) {
          this.setfailedResult(true);
          break;
        }
        else if (!status.localeCompare("duplicate", undefined, { sensitivity: 'accent' })) {
          duplicateId = true;
          if (isApplication === 'true') {
            this.setIsLoadingFunc(false);
            this.setShowIframe(false);
            break;
          } else {
            this.getVerifastUrl();
            break;
          }
        }
        await this.timeout(5000);
      }
      if(duplicateId){
        this.errorService.showError("This ID is already being used. Please try again and use a different identification.");
      }
      else {
        if(isApplication === 'true') {
          this.setShowIframe(false);
        }
        this.setIsLoadingFunc(false);
        this.errorService.showError("Unable to verify Verifast results. Please contact customer support.");
      }
    })();
  }

  timeout(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}
